import React from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import StoreForm from './StoreForm'
import { storeStore } from '../services'
import { handleError } from '../../../helpers'

export default function NewStoreModal({ visible, onClose, reload }) {
	const auth = useSelector(state => state.auth)
	const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm()

	const onSubmit = values => {
		values.user_id = auth.user.id
		storeStore(values)
			.then(() => {
				message.success('Tienda creada exitosamente.')
				reset()
				reload()
				onClose()
			})
			.catch(error => handleError(error))
	}	

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Registrar Tienda</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<StoreForm register={register} errors={errors} setValue={setValue} />
						<Button type="submit" color="primary">Crear Tienda</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}